import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Updater from './_Updater';
// import styled from 'styled-components';

// const Div = styled.div`
//   height: 100%;
//   width: 100%;
// `

class EditRight extends Component {
  constructor() {
    super()
    this.state = { size: {width: 0, height: 0}}
  }
  shouldComponentUpdate(nextProps, nextState) {
    // console.log('SHOULD?', nextProps, this.props);
    // console.log('BOOL', !(this.nameDescTags(nextProps, this.props)));
    // return !(this.nameDescTags(nextProps, this.props))
    // console.log('NEXT STATE:', nextState, 'THIS STATE:', this.state);
    return  JSON.stringify(nextState) !== JSON.stringify(this.state) ||
            this.should(this.deepCopy(nextProps), this.deepCopy(this.props));
    // return nextProps.envelope.resizeStop;
  }
  should = (n, t) => {
    if (this.str(n) === this.str(t)) return false;
    if (n.envelope) {
      n.envelope.name   = '';
      n.envelope.description  = '';
      n.envelope.tags = '';
    }
    if (t.envelope) {
      t.envelope.name   = '';
      t.envelope.description  = '';
      t.envelope.tags = '';
    }
    if (this.str(n) !== this.str(t)) return true;
    return false;
  }
  str = (o) => {
    return JSON.stringify(o);
  }
  deepCopy = (o) => {
    return JSON.parse(JSON.stringify(o));
  }
  nameDescTags = (n, t) => {
    return  n.envelope && t.envelope &&
            n.envelope.name        === t.envelope.name &&
            n.envelope.tags        === t.envelope.tags &&
            n.envelope.description === t.envelope.description
  }

  componentDidUpdate(prevProps, prevState) {
    const size = this.getDimensions();
    // console.log(size);
    if (JSON.stringify(this.state.size) !== JSON.stringify(size) ) {
      this.setState({ size });
    }
  }

  render() {
    // console.log(this.state.size);
    // const style = JSON.parse(JSON.stringify(this.state.size));
    // style.border = "0";
    const styleProps = {
      border: '0',
      width: this.state.size.width,
      height: this.state.size.height
    }
    return (
      <div ref='parent'>
        <Updater
          styleProps={styleProps}
          envelope={this.props.envelope}
          resizeStop={this.props.resizeStop}
        />
      </div>
    )
  }
  getDimensions() {
    // var parent = this.refs.parent;
    var div = ReactDOM.findDOMNode(this)
    var parent = div.parentNode;
    // console.log(parent);
    return { width: parent.clientWidth, height: parent.clientHeight };
  }
}

export default EditRight;



// WEBPACK FOOTER //
// ./src/_EditRight.js